import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import CustomerGateway from '~apis/customer';
import { TGetCustomerInventoryReduxParams } from '~types/feat/customer';
import { PayloadAction } from '@reduxjs/toolkit';
import silver from '~sagas/silver';
import { MetalTypeEnum } from '~utils/enums';

export default function* watchGetCustomerInventory(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerInventoryAttempt', handleGetCustomerInventory, api);
}

function* handleGetCustomerInventory(api: CustomerGateway, data: PayloadAction<TGetCustomerInventoryReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { customerId, goldType, silverType, metalType } = data.payload;

    const response = yield* call([api, api.getCustomerInventory], {
        authToken,
        metalType,
        customerId,
        ...(metalType === MetalTypeEnum.Gold ? { goldType } : { silverType }),
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerInventoryFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerInventorySuccess(response.data));

        if (data.payload.notifyIfEmpty && response.data.length === 0) {
            toast.error(ErrorMessages.CustomerHasNoInventoryError);
        }
    }
}
